import { Routes } from '@angular/router';
import { ComingSoonPageComponent } from './Pages/coming-soon-page/coming-soon-page.component';
import { PageMaintenanceComponent } from './Pages/page-maintenance/page-maintenance.component';
import { PageNotFoundComponent } from './Pages/page-not-found/page-not-found.component';


export const routes: Routes = [
    {
    path: "",
    redirectTo: "",
    pathMatch: "full"
  },
  {
    path: "",
    loadChildren: () =>
      import("./Layouts/main-layout/main-layout.module").then((m) => m.MainLayoutModule)
  },
  {
    path: "maintenance",
    component: PageMaintenanceComponent
  },
  {
    path: "coming-soon",
    component: ComingSoonPageComponent
  },


  {
    path: "mobile",
    loadChildren: () =>
      import("./Pages/mobile-page/mobile-page.module").then((m) => m.MobilePageModule)
  },


  {
    path: "**",
    component: PageNotFoundComponent
  }
];